import React from "react";

import { Container, Row, Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import {
  FaWarehouse,
  FaBullhorn,
  FaShippingFast,
  FaMoneyBillWave,
  FaHeadset,
  FaPuzzlePiece,
} from "react-icons/fa";
export default function FulfillmentSolution() {
  const { lang } = useParams();
  const [_] = useTranslation("global");
  const data = [
    {
      key: "storagePackaging",
      icon: <FaWarehouse size={100} color="rgb(89, 198, 201)" />, 
    },
    {
      key: "packagingShipping",
      icon: <FaShippingFast size={100} style={{ color: "rgb(89, 198, 201)" }} />, 
    },
    {
      key: "collection",
      icon: <FaMoneyBillWave size={100} style={{ color: "rgb(89, 198, 201)" }} />, 
    },
    {
      key: "technology",
      icon: <FaPuzzlePiece size={100} style={{ color: "rgb(89, 198, 201)" }} />, 
    },
    {
      key: "orderConfirmation",
      icon: <FaHeadset size={100} style={{ color: "rgb(89, 198, 201)" }} />, 
    },
    {
      key: "trackingControl",
      icon: <FaBullhorn size={100} style={{ color: "rgb(89, 198, 201)" }} />, 
    },
  ];

  return (
    <section
      className="py-5 overflow-hidden"
      dir={lang === "en" ? "ltr" : "rtl"}
      id="fulfillmentSolution"
    >
      <div className="text-center mb-5" data-aos="fade-up" data-aos-delay={100}>
        <h2 className="ecombo-primary fw-bold">
          {_("fulfillment_landing.fulfillmentSolution.title")}
        </h2>
        <p>{_("fulfillment_landing.fulfillmentSolution.description")}</p>
      </div>

      <Container className="mt-5">
        <Row className="justify-content-center">
          {data.map((item, idx) => {
            const middle = idx === 1;
            return (
              <Col
                key={item.key}
                xs={12}
                sm={6}
                md={4}
                className={`d-flex justify-content-center mb-4  ${middle ? "" : "mt-5"}`}
                data-aos="fade-up"
                data-aos-delay={idx * 200}
              >
                <Card
                  style={{ backgroundColor: "#FEF5E9" }}
                  className="  p-4 rounded-lg text-center border-0"
                >
                  <span style={{ fontSize: "100px" }}>{item.icon}</span>
                  <h2 className="text-3xl font-normal ecombo-primary">
                    {_("fulfillment_landing.fulfillmentSolution." + item.key + ".title")}
                  </h2>
                  <p className="max-w-[280px] mx-auto">
                    {_("fulfillment_landing.fulfillmentSolution." + item.key + ".description")}
                  </p>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
}
